import React, { useState, useEffect } from 'react';
import './left.css';
import { TIPO_STOCK } from '../../Global';


export function IslandSelector({ onSelectItem, isBlocked }) {
    const [pendings, setPendings] = useState([]);
    const [activeDispensers, setActiveDispensers] = useState({});
    const [selectedCara, setSelectedCara] = useState(null);
    const [islas, setIslas] = useState([])
    const [apiIsRunning, setApiIsRunning] = useState(false);
    const [activeIslas, setActiveIslas] = useState([]);

    useEffect(() => {
        const fetchApiIsRunning = async () => {
            try {
                const response = await fetch('http://localhost:8080/api/v1/ping');

                if (!response.ok) {
                    setApiIsRunning(false);
                    return;
                }

                const jsonData = await response.json();
                setApiIsRunning(jsonData.code == 'MFP-SURTIDORES');
            } catch (error) {
                setApiIsRunning(false);
            }
        }

        fetchApiIsRunning();
    }, []);

    useEffect(() => {
        const fetchIslas = async () => {
            const response = await fetch('http://localhost:8080/api/v1/islas');

            if (!response.ok) {
                setIslas([]);
                return;
            }

            const jsonData = await response.json();
            setIslas(jsonData);
        }

        if (apiIsRunning) {
            fetchIslas();
        }
    }, [apiIsRunning]);

    useEffect(() => {
        const fetchActiveIslas = async () => {
            const response = await fetch('/api/third-party/active-islas');
            const jsonData = await response.json();
            setActiveIslas(jsonData);
        }

        if (apiIsRunning) {
            fetchActiveIslas();
        }
    }, [apiIsRunning]);

    const fetchProds = async (query = '', callback = null) => {
        const url = `/api/preVentas/?search=${query}&idTipoStock=${TIPO_STOCK.CON_COMPROBANTE}`
        const response = await fetch(url)
        const data = await response.json();
        return data;
    }

    useEffect(() => {
        const caraItems = document.querySelectorAll('.cara-item');
        
        caraItems.forEach(cara => {
            cara.classList.remove('cara-active', 'cara-inactive', 'cara-pending');

            if (selectedCara == null) {
                const caraId = cara.id.split('-')[1];
                const isPending = pendings.some(pending => pending.cara == caraId);
            
                cara.classList.add(isPending ? 'cara-pending' : 'cara-inactive');
                cara.disabled = !isPending;
            } else if (selectedCara == cara.id.split('-')[1]) {
                cara.classList.add('cara-selected');
                cara.disabled = false;
            } else {
                cara.classList.add('cara-inactive');
                cara.disabled = true;
            }
        });
        
    }, [pendings, selectedCara])

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('http://localhost:8080/api/v1/pendientes');
                const jsonData = await response.json();
                setPendings(jsonData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        if (apiIsRunning) {
            fetchData();
            const intervalId = setInterval(fetchData, 5000);
            return () => clearInterval(intervalId);
        }

    }, [apiIsRunning]);

    useEffect(() => {
        if (!apiIsRunning) {
            return;
        }

        const ws = new WebSocket('ws://localhost:8080/ws');

        ws.onopen = () => {
            console.log('WebSocket Connected');
        };

        ws.onmessage = (event) => {
            const data = JSON.parse(event.data);
            
            switch(data.type) {
                case 'start':
                    setActiveDispensers(prev => ({
                        ...prev,
                        [data.key]: {
                            active: true,
                            producto: data.producto,
                            volumen: 0,
                            importe: 0
                        }
                    }));
                    break;
                
                case 'progress':
                    setActiveDispensers(prev => ({
                        ...prev,
                        [data.key]: {
                            ...prev[data.key],
                            volumen: data.volumen,
                            importe: data.importe
                        }
                    }));
                    break;
                
                case 'end':
                    setActiveDispensers(prev => {
                        const newState = { ...prev };
                        delete newState[data.key];
                        return newState;
                    });
                    break;
            }
        };

        ws.onerror = (error) => {
            console.error('WebSocket error:', error);
        };

        ws.onclose = () => {
            console.log('WebSocket Disconnected');
        };

        return () => {
            ws.close();
        };
    }, [apiIsRunning]);

    const toggleDispensador = (islaNumero, caraNumero) => {
        setIslas(prevIslas => 
            prevIslas.map(isla => 
                isla.numero === islaNumero
                    ? {
                        ...isla,
                        caras: isla.caras.map(cara =>
                            cara.numero === caraNumero
                                ? { ...cara, dispensadorActivo: !cara.dispensadorActivo }
                                : cara
                        )
                    }
                    : isla
            )
        );
    };

    const onCaraClick = async (numeroCara) => {
        const pendingSale = pendings.find(pending => pending.cara === numeroCara);
        if (!pendingSale) {
            return;
        }

        sessionStorage.setItem('surtidores-pending-sale', pendingSale.id);

        const response = await fetchProds(pendingSale.producto);
        
        if (!('productos' in response) || !Array.isArray(response.productos) || response.productos.length != 1) {
            return;
        }

        const producto = response.productos[0];
        onSelectItem(producto, null, pendingSale.volumen);
    }

    if (!apiIsRunning) {
        return null;
    }
    const getPendingVol = (caraNumero) => {
        const pendingSale = pendings.find(pending => pending.cara === caraNumero);
        if (!pendingSale || !pendingSale.volumen) return null;
        return pendingSale.volumen.toFixed(3);
    };
    const getPendingImporte = (caraNumero) => {
        const pendingImport = pendings.find(pending => pending.cara === caraNumero);
        if (!pendingImport || !pendingImport.importe) return null;
        return pendingImport.importe.toFixed(2);
    }

    return (
        <div className='abed__content__islas'>
            <div className='abed__content__islas__isla'>
                <div className="islas-container">
                    {islas.filter(isla => activeIslas.includes(isla.id)).map(({ id, caras }, index) => (
                        <div key={`isla-${id}`} className="isla-item">
                            <div className="isla-header">
                                <span className="isla-number text-white">Isla 0{id}</span><br />
                            </div>
                            <div className="caras-container">
                                {caras.map((cara) => {
                                    const dispenserStatus = false;
                                    const volumen = getPendingVol(cara);
                                    const importe = getPendingImporte(cara);
                                    return (
                                        <button
                                            key={`cara-${cara}`}
                                            id={`cara-${cara}`}
                                            className={`cara-item ${dispenserStatus ? 'cara-active' : 'cara-inactive'} ${
                                                importe > 699 && isBlocked ? 'abed__cara-bloqued' : ''
                                            }`}
                                            type="button"
                                            disabled={importe > 699 && isBlocked}
                                            onClick={() => {
                                                if (selectedCara == null && !(importe > 699 && isBlocked)) {
                                                    setSelectedCara(cara);
                                                    onCaraClick(cara);
                                                }
                                            }}
                                        >
                                            <div className='abed__cara_content'>
                                                <span className="cara-numero">{cara}</span>
                                                {volumen && importe && (

                                                    <div class="abed__cara-info-line">
                                                        <div class="cara-info-group">
                                                            <span class="cara-label">galones</span>
                                                            <span class="cara-value">{volumen}</span>
                                                        </div>
                                                        <div class="cara-info-group">
                                                            <span class="cara-label">importe</span>
                                                            <span class="cara-value">{importe}</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default IslandSelector;
